import type { SubmitPayload } from "../types";

/**
 * Что делать с текстом, который юзер написал в каталоге: править фото или рисовать с нуля.
 *
 * Правило одно на весь продукт и уже живёт в ядре бота (`bot/core/flow/text.ts`): есть
 * фото — текст правит его; нет фото — текст рисует картинку с нуля. Каталог обязан вести
 * себя так же, иначе один и тот же текст в чате и в мини-аппе делал бы разное.
 *
 * Отдельно и с именем — потому что раньше каталог без фото слал `custom` (правку), и это
 * был тупик: правку не к чему применять, бот отвечал «пришли фото», а набранный текст
 * терялся. `create` в той же ситуации рисует сразу.
 */
/** Только те kind'ы, что несут текст: "preset" сюда не относится — там выбран шаблон. */
type PromptKind = Extract<SubmitPayload, { prompt: string }>["kind"];

export function submitKindForPrompt(hasPhoto: boolean): PromptKind {
  return hasPhoto ? "custom" : "create";
}
